// extracted by mini-css-extract-plugin
export default {"download-calculation-pdf-button":"DownloadCalculationDetails_download-calculation-pdf-button__gbiRY"};